import InputAutoComplete from './InputAutoComplete';

export default InputAutoComplete;